import React from "react";
import Image from "next/image";
import IMAGES from "@/public/assets/img";
import Link from "next/link";
import { pushCleverTapEvent } from "./pushCleverTapEvent";

const DownloadApp = () => {
  return (
    <section className="pt-16 sm:pt-14">
      <div className="container px-3 xm:px-2">
      <div className="bg-[#FECE2E] rounded-xl pl-12 sm:pl-0 sm:text-center">
        <div className="flex pt-4 w-full sm:flex-col">
          <div className="w-3/5 sm:w-full flex-col sm:px-4">
            <div className="text-textxl text-brand font-bold mt-1 sm:text-xl">
              Download Our App and Simplify Your Funding Process
            </div>
            <div className="text-base mt-1 text-brand w-3/4 sm:w-full">
              Streamline your business fund requirement with our user-friendly
              app Download now and save time.
            </div>
            <div className="flex mt-3 sm:justify-center">
              <Link
                href="https://play.google.com/store/apps/details?id=com.moglix.credlix"
                target="_blank"
                rel="noopener noreferrer"
                onClick={()=>pushCleverTapEvent("Google_Play_Download",{"PageName": 'HomePage',})}
              >
                <Image
                  src={IMAGES.appbanner.googlePlayBtn}
                  width={140}
                  className="w-[140px] mr-2 h-auto"
                  height={40}
                  alt="Google Play Btn"
                  quality={100}
                />
              </Link>
              <Link
                href="https://apps.apple.com/in/app/credlix/id6733239250"
                target="_blank"
                rel="noopener noreferrer"
                onClick={()=>pushCleverTapEvent("IOS_Appstore_Download",{"PageName": 'HomePage',})}
              >
                <Image
                  src={IMAGES.appbanner.appStoreBtn}
                  width={140}
                  className="w-[140px] h-auto"
                  height={40}
                  alt="App Store Btn"
                  quality={100}
                />
              </Link>
            </div>
          </div>
          <div className="w-[40%] sm:w-full sm:mt-3">
            <Image
              src={IMAGES.appbanner.indiaTradeBanner}
              width={465}
              style={{ width: "auto", height: "auto" }} 
              height={196}
              alt="India Trade"
              className="sm:h-[177px] sm:w-"
            />
          </div>
        </div>
      </div>
      </div>
    </section>
  );
};

export default DownloadApp;
